import { useSelector, shallowEqual } from 'react-redux';
import keyMirror from '@app/redux/keyMirror';

const INITIAL_STATE = {
  currentIndex: 0,
  recognizedWords: [],
  answers: [],
  isStarted: false,
  isFinished: false,
  userRightAnswer: null,
};

const constants = keyMirror([
  'EXERCISE.SET-CURRENT-INDEX',
  'EXERCISE.SET-RECOGNIZED-WORDS',
  'EXERCISE.SET-ANSWERS',
  'EXERCISE.SET-IS-STARTED',
  'EXERCISE.SET-IS-FINISHED',
  'EXERCISE.SET-USER-RIGHT-ANSWER',
  'EXERCISE.RESET-USER-RIGHT-ANSWER',
]);

export const setIsStarted = (value) => ({
  type: constants['EXERCISE.SET-IS-STARTED'],
  payload: { value },
});

export const setIsSFinished = (value) => ({
  type: constants['EXERCISE.SET-IS-FINISHED'],
  payload: { value },
});

export const setCurrentIndex = (value) => ({
  type: constants['EXERCISE.SET-CURRENT-INDEX'],
  payload: { value },
});

export const setRecognizedWords = (value) => ({
  type: constants['EXERCISE.SET-RECOGNIZED-WORDS'],
  payload: { value },
});

export const resetRecognizedWords = () => ({
  type: constants['EXERCISE.SET-RECOGNIZED-WORDS'],
  payload: { value: INITIAL_STATE.recognizedWords },
});

export const setAnswers = (value) => ({
  type: constants['EXERCISE.SET-ANSWERS'],
  payload: { value },
});

export const setUserRightAnswer = (value) => ({
  type: constants['EXERCISE.SET-USER-RIGHT-ANSWER'],
  payload: { value },
});

export const resetUserRightAnswer = () => ({
  type: constants['EXERCISE.RESET-USER-RIGHT-ANSWER'],
});

export const selectCurrentIndex = ({ exercise }) => exercise.currentIndex;
export const useSelectCurrentIndex = () => useSelector(selectCurrentIndex, shallowEqual);

export const selectRecognizedWords = ({ exercise }) => exercise.recognizedWords;
export const useSelectRecognizedWords = () => useSelector(selectRecognizedWords, shallowEqual);

export const selectAnswers = ({ exercise }) => exercise.answers;
export const useSelectAnswers = () => useSelector(selectAnswers, shallowEqual);

export const selectIsStarted = ({ exercise }) => exercise.isStarted;
export const useSelectIsStarted = () => useSelector(selectIsStarted, shallowEqual);

export const selectIsFinished = ({ exercise }) => exercise.isFinished;
export const useSelectIsFinished = () => useSelector(selectIsFinished, shallowEqual);

export const selectUserRightAnswer = ({ exercise }) => exercise.userRightAnswer;
export const useSelectUserRightAnswer = () => useSelector(selectUserRightAnswer, shallowEqual);

export const reducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case constants['EXERCISE.SET-CURRENT-INDEX']: {
      return { ...state, currentIndex: payload.value };
    }
    case constants['EXERCISE.SET-RECOGNIZED-WORDS']: {
      return { ...state, recognizedWords: payload.value };
    }
    case constants['EXERCISE.SET-ANSWERS']: {
      return { ...state, answers: payload.value };
    }
    case constants['EXERCISE.SET-IS-STARTED']: {
      return { ...state, isStarted: payload.value };
    }
    case constants['EXERCISE.SET-IS-FINISHED']: {
      return { ...state, isFinished: payload.value };
    }
    case constants['EXERCISE.RESET-USER-RIGHT-ANSWER']: {
      return { ...state, userRightAnswer: INITIAL_STATE.userRightAnswer };
    }
    case constants['EXERCISE.SET-USER-RIGHT-ANSWER']: {
      return { ...state, userRightAnswer: payload.value };
    }
    default:
      return state;
  }
};
